import { ZustandNavigationBarStore } from './types';

export const getNavBarPortalInfoSelector = (store: ZustandNavigationBarStore) =>
  store.portalInfo;

export const setNavbarPortalInfoAction = (store: ZustandNavigationBarStore) =>
  store.setPortalInfo;
